function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Head } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
import { Link } from '@inertiajs/inertia-vue3';
import axios from 'axios';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Pagination: Pagination,
    SearchFilter: SearchFilter,
    Link: Link
  },
  layout: Layout,
  props: {
    internalTenants: Object
  },
  data: function data() {
    return {
      selectedSettings: {
        tenant_list: true,
        follow_up_time: false,
        follow_up_end_time: false,
        interval: false,
        contacts_per_company: false,
        emails_per_minute: false,
        emails_per_day: false,
        emails_per_day_total: false
      },
      campaignSettings: _objectSpread({}, this.defaultCampaignSettings()),
      settingChanges: {
        data: [],
        meta: {
          current_page: 1,
          total: 0,
          per_page: 10
        }
      }
    };
  },
  computed: {
    allSettingsSelected: function allSettingsSelected() {
      return Object.values(this.selectedSettings).every(function (value) {
        return value === true;
      });
    }
  },
  mounted: function mounted() {
    this.handlePageChange();
  },
  methods: {
    defaultCampaignSettings: function defaultCampaignSettings() {
      return {
        emails_per_day: 200,
        emails_per_day_total: 1000,
        emails_per_minute: 5,
        contacts_per_company: 2,
        follow_up_time: '10:00',
        follow_up_end_time: '17:00',
        tenant_list: [],
        interval: ''
      };
    },
    // toggleAllSettings() {
    //   const newValue = !this.allSettingsSelected
    //   Object.keys(this.selectedSettings).forEach((key) => {
    //     this.selectedSettings[key] = newValue
    //   })
    // },
    getActiveCampaignSettings: function getActiveCampaignSettings() {
      var _this = this;
      var settings = {};
      Object.keys(this.selectedSettings).forEach(function (key) {
        if (_this.selectedSettings[key]) {
          settings[key] = _this.campaignSettings[key];
        }
      });
      return settings;
    },
    saveCampaignSettings: function saveCampaignSettings() {
      var _this2 = this;
      var settings = this.getActiveCampaignSettings();
      if (!settings.tenant_list || settings.tenant_list.length === 0) {
        ElMessage({
          showClose: true,
          message: 'Please select the tenants.',
          type: 'error'
        });
        return;
      }
      for (var _i = 0, _Object$keys = Object.keys(settings); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (settings[key] === '' || settings[key] === null || Array.isArray(settings[key]) && settings[key].length === 0) {
          ElMessage({
            showClose: true,
            message: "Please fill in all selected settings. Missing: ".concat(key),
            type: 'error'
          });
          return;
        }
      }
      if (settings.interval && settings.interval.split(',').map(Number).includes(0)) {
        ElMessage({
          showClose: true,
          message: 'Interval cannot contain zero.',
          type: 'error'
        });
        return;
      }
      this.$inertia.form(settings).post('/campaigns/save-bulk-settings');
      this.$inertia.on('success', function () {
        _this2.handlePageChange();
      });
    },
    resetCampaignSettings: function resetCampaignSettings() {
      this.campaignSettings = _objectSpread({}, this.defaultCampaignSettings());
      this.selectedSettings = _objectSpread(_objectSpread({}, Object.keys(this.selectedSettings).reduce(function (acc, key) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, false));
      }, {})), {}, {
        tenant_list: true
      });
    },
    handlePageChange: function handlePageChange() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var page;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this3.settingChanges.meta.current_page = page;
                _context.next = 4;
                return axios.get('/campaigns/bulk-update-changes', {
                  params: {
                    page: page
                  }
                }).then(function (response) {
                  console.log('Response:', response);
                  _this3.settingChanges = response.data.settingChanges;
                })["catch"](function (error) {
                  console.error('Error fetching data:', error);
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    formatDateTime: function formatDateTime(dateString) {
      var date = new Date(dateString);
      var pad = function pad(n) {
        return n.toString().padStart(2, '0');
      };
      var day = pad(date.getDate());
      var month = pad(date.getMonth() + 1);
      var year = date.getFullYear();
      var hours = pad(date.getHours());
      var minutes = pad(date.getMinutes());
      var seconds = pad(date.getSeconds());
      return "".concat(day, "-").concat(month, "-").concat(year, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};